import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarAutorizacoes(axios) {
    let parametros = {
      operacao: 'buscarAutorizacoes'
    };
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarDadosCadastro(axios, parametros) {       
    parametros.operacao = 'buscarDadosCadastro';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },
  
  async buscarObservacoesCadastro(axios, parametros) {       
    parametros.operacao = 'buscarObservacoesCadastro';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarReferencias(axios, parametros) {       
    parametros.operacao = 'buscarReferencias';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarSpcSerasa(axios, parametros) {       
    parametros.operacao = 'buscarSpcSerasa';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarSocios(axios, parametros) {       
    parametros.operacao = 'buscarSocios';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarListaNegra(axios, parametros) {       
    parametros.operacao = 'buscarListaNegra';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarTotalizadorPedidos(axios, parametros) {       
    parametros.operacao = 'buscarTotalizadorPedidos';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarPedidos(axios, parametros) {       
    parametros.operacao = 'buscarPedidos';
    let retorno = {};

    await axios.santriPOST('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarItensPedidos(axios, parametros) {       
    parametros.operacao = 'buscarItensPedidos';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarAcumulativoAberto(axios, parametros) {       
    parametros.operacao = 'buscarAcumulativoAberto';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarCreditos(axios, parametros) {       
    parametros.operacao = 'buscarCreditos';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 30, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarDevolucoesPendentes(axios, parametros) {       
    parametros.operacao = 'buscarDevolucoesPendentes';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarPedidoRecEntregaNaoRecebido(axios, parametros) {       
    parametros.operacao = 'buscarPedidoRecEntregaNaoRecebido';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 30, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarNotasFiscais(axios, parametros) {       
    parametros.operacao = 'buscarNotasFiscais';
    let retorno = {};

    await axios.santriPOST('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarOcorrencias(axios, parametros) {       
    parametros.operacao = 'buscarOcorrencias';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },
 
  async buscarRedesSociais(axios, parametros) {       
    parametros.operacao = 'buscarRedesSociais';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarTotalizadorFinanceirosAbertos(axios, parametros) {       
    parametros.operacao = 'buscarTotalizadorFinanceirosAbertos';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarFinanceirosAbertos(axios, parametros) {       
    parametros.operacao = 'buscarFinanceirosAbertos';
    let retorno = {};

    await axios.santriPOST('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarTotalizadorFinanceirosBaixados(axios, parametros) {       
    parametros.operacao = 'buscarTotalizadorFinanceirosBaixados';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarFinanceirosBaixados(axios, parametros) {       
    parametros.operacao = 'buscarFinanceirosBaixados';
    let retorno = {};

    await axios.santriPOST('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },


  async buscarTotalizadorFinanceirosUnificados(axios, parametros) {       
    parametros.operacao = 'buscarTotalizadorFinanceirosUnificados';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarFinanceirosUnificados(axios, parametros) {       
    parametros.operacao = 'buscarFinanceirosUnificados';
    let retorno = {};

    await axios.santriPOST('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarResumoVendas(axios, parametros) {       
    parametros.operacao = 'buscarResumoVendas';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async buscarResumoFinanceiros(axios, parametros) {       
    parametros.operacao = 'buscarResumoFinanceiros';
    let retorno = {};

    await axios.santriGET('/rest/vidaCliente', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

}


// WEBPACK FOOTER //
// ./src/components/Rest/RVidaCliente.js